// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610010211/js/" + chunkId + "." + {"44":"f0668250","225":"4a3ba066","481":"fdebb7c3","486":"298d72d6","770":"65a99ab7"}[chunkId] + ".0.4196299753593158.chunk.js";
};